export default {
  data () {
    return {
      fields: [
        {
          prop: 'applicant_name',
          label: '申请人',
          width: 120,
        },
        {
          prop: 'department_name',
          label: '部门',
          minWidth: 120,
        },
        {
          prop: 'type',
          label: '付款类型',
          minWidth: 90,
          formatter: this.formatterPaymentType,
        },
        {
          prop: 'payment_channel_type',
          label: '付款渠道',
          minWidth: 150,
          formatter: this.formatterPaymentChannelType,
        },
        {
          prop: 'desc',
          label: '付款说明',
          width: 100,
        },
        {
          prop: 'payment_company',
          label: '付款公司',
          minWidth: 90,
          formatter: this.formatterPaymentCompany,
        },
        {
          prop: 'apply_amount',
          label: '应付金额',
          minWidth: 90,
        },
        {
          prop: 'confirm_amount_total',
          label: '确认金额',
          minWidth: 90,
        },
        {
          prop: 'paid_amount_total',
          label: '实付金额',
          width: 153,
        },
        {
          prop: 'status',
          label: '付款状态',
          width: 123,
          formatter: (row) => {
            if (!this.status || row.status === undefined || row.status === null) {
              return '-'
            }
            return this.status[row.status] || '-'
          },
        },
        {
          prop: 'review_user_name',
          label: '当前审批人',
          width: 153,
          formatter: this.formatterReviewUserName
        },
        {
          prop: 'created_at',
          label: '申请日期',
          width: 160,
        },
        {
          prop: 'paid_date',
          label: '付款日期',
          width: 153,
          formatter: this.formatterPaidDate
        },
        {
          prop: 'updated_at',
          label: '更新日期',
          width: 160,
        },
        // {
        //   prop: 'write_off_status',
        //   label: '冲销状态',
        //   width: 80,
        //   formatter: this.formatterWriteOffStatus
        // },
      ],
    }
  },
  computed: {
    ...Vuex.mapState({
      type: state => state.paymentManagerNew.type,
      status: state => state.paymentManagerNew.status,
      paymentChannelTypes: state => state.paymentManagerNew.paymentChannelTypes,
      paymentAccountTypes: state => state.paymentManagerNew.paymentAccountTypes,
    }),
  },
  methods: {
    formatterPaymentChannelType (row) {
      if (row.payment_channel_type === 0) {
        return '-'
      }
      if ([1, 3].includes(row.type)) {
        return this.paymentChannelTypes[1] || '单笔付款'
      }
      if (row.type !== 2) {
        return '-'
      }
      if (row.payment_channel_type === 1) {
        return this.paymentChannelTypes[1] || '单笔付款'
      }
      if (row.payment_channel_type === 2) {
        const channelLabel = this.paymentChannelTypes[2] || '零工提现'
        const accountLabel = this.paymentAccountTypes[row.payment_account_type]
        return accountLabel ? `${channelLabel}（${accountLabel}）` : channelLabel
      }
      return '-'
    },
    formatterPaymentType (row) {
      return (this.type && this.type[row.type]) || '-'
    },
    formatterReviewUserName (row) {
      if (row.status === 1) {
        return row.first_approver_name
      } else if (row.status === 2) {
        return row.second_approver_name
      } else if (row.status === 3) {
        return row.third_approver_name
      } else if (row.status === 4) {
        return row.fourth_approver_name
      } else if (row.status === 5) {
        return '费用会计'
      } else if (row.status === 6) {
        return '财务经理'
      } else if (row.status === 13) {
        return row.department_approver_name
      } else if (row.status === 14) {
        return row.special_approver_name
      }
      return '-'
    },
    formatterPaidDate (row) {
      if (row.paid_date !== '0000-00-00 00:00:00') {
        return row.paid_date.substr(0, 10)
      }
      return '-'
    },
    formatterPaymentCompany (row) {
      if (!this.paymentCompanys || row.payment_company === undefined || row.payment_company === null) {
        return '-'
      }
      return this.paymentCompanys[row.payment_company] || '-'
    },
    // formatterWriteOffStatus (row) {
    //   if (row.type !== 3 || ![8, 10].includes(row.status)) {
    //     return '-'
    //   }
    //   for (const key in this.writeOffStatus) {
    //     if (key * 1 === row.write_off_status * 1 && Object.hasOwnProperty.call(this.writeOffStatus, key)) {
    //       return this.writeOffStatus[key]
    //     }
    //   }
    //   return '-'
    // },
  },
}




// WEBPACK FOOTER //
// ./src/views/payment-center/payment-center.mixins.js